import * as React from "react";
import { getBexApiContext, Context } from "bernie-context";
import { AnalyticsStore, PageStore } from "bernie-core";
import { inject } from "mobx-react";
import { CustomerNotificationWithDialog } from "./NotificationsWithDialog/CustomerNotificationWithDialog";
import { getIdentity } from "./NotificationsWithDialog/NotificationQueryUtils";

interface CustomerNotificationsWithDialogProps {
  context?: Context;
  analytics?: AnalyticsStore;
  location: string;
  page?: PageStore;
  className?: string;
}

export const CustomerNotificationsWithDialogWrapper: React.FC<CustomerNotificationsWithDialogProps> = inject(
  "analytics",
  "context",
  "page"
)((props: CustomerNotificationsWithDialogProps) => {
  const { analytics, context, location, page, className = "all-b-margin-three" } = props;

  if (!page || !page.pageId || !context) {
    return null;
  }

  const identity = getIdentity(page);

  /* istanbul ignore next */
  const analyticsCallback = (rfrr: string, linkName: string | null) => {
    analytics?.trackEvent(rfrr, linkName || "RFRR Action Event", analytics.omnitureData, null, true);
  };

  return (
    <React.Fragment>
      <CustomerNotificationWithDialog
        inputs={{
          context: getBexApiContext(context),
          lineOfBusiness: identity.lineOfBusiness,
          funnelLocation: identity.funnelLocation,
          location,
        }}
        analyticsCallback={analyticsCallback}
        className={className}
      />
    </React.Fragment>
  );
});
